// extracted by mini-css-extract-plugin
module.exports = {"main":"loader_main__W9onu","loader":"loader_loader__h6F1S","mainText":"loader_mainText__F18Tm","loaderText":"loader_loaderText__bRJsU","dots":"loader_dots__IlTpx"};